import script from "./TeamSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./TeamSearchBar.vue?vue&type=style&index=0&id=e12ecdf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e12ecdf6"]])

export default __exports__